import { useFields } from './Fields.h'
import { useEstimation } from '@shared/hooks/estimation'

import { Controller } from 'react-hook-form'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import FormControlLabel from '@mui/material/FormControlLabel'
import ListSubheader from '@mui/material/ListSubheader'
import MenuItem from '@mui/material/MenuItem'
import Stack from '@mui/material/Stack'
import Tab from '@mui/material/Tab'
import List from '@mui/material/List'
import Tabs from '@mui/material/Tabs'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import LinearProgress from '@mui/material/LinearProgress'
import IconButton from '@mui/material/IconButton'
import FormTextField from '@shared/components/FormTextField'
import Images from './Images'
import AddIcon from '@mui/icons-material/Add'
import PostAddIcon from '@mui/icons-material/PostAdd'
import Attachments from './Attachments'
import SignatureField from '@shared/components/SignatureField'
import Divider from '@mui/material/Divider'
import ConsultantItem from '@shared/components/ConsultantItem'
import since from '@shared/utils/since'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'

export default function Fields() {
    const {
        instance,
        handleClose,
        workType,
        control,
        dialogMode,
        loading,

        tab,
        setTab,

        viewDocs,
        viewCropper,

        images,
        imgUploaderRef,
        uploadImage,

        attachments,
        atchUploaderRef,
        uploadAttachment,

        offices,
        delegates
    } = useFields()
    const { handlePreview } = useEstimation(instance)

    return (
        <>
            {(offices.isLoading || delegates.isLoading) && <LinearProgress sx={{height: 10}}/>}
            {dialogMode == 'fields' &&
                <>
                    <DialogTitle>{instance ? 'تعديل' : 'إضافة'}</DialogTitle>
                    <Tabs
                        value={tab}
                        onChange={(e, v) => setTab(v)}
                        variant='scrollable'
                        scrollButtons
                    >
                        <Tab value='general' label='عام'/>
                        <Tab value='documents' label={`النماذج (${images.filter(img => img.dep === 'documents').length})`}/>
                        <Tab value='location' label={`الموقع (${images.filter(img => img.dep === 'location').length})`}/>
                        <Tab value='violations' label={`مخالفات السلامة (${images.filter(img => img.dep === 'violations').length})`}/>
                        <Tab value='attachments' label={`المرفقات (${attachments.length})`}/>
                    </Tabs>
                    <Divider />
                </>
            }
            <DialogContent sx={{display: dialogMode == 'fields' ? 'block' : 'none'}}>
                <Stack sx={{display: tab === 'general' ? 'auto' : 'none'}}>
                    {!!instance &&
                        <Typography
                            variant='body2'
                            color='textSecondary'
                        >تاريخ الإنشاء: {since(instance.created_at)}</Typography>
                    }
                    <FormTextField
                        name='number'
                        label='رقم المقايسة *'
                    />
                    <FormTextField
                        name='contractor'
                        label='المقاول *'
                    />
                    <FormTextField
                        name='work_type'
                        label='نوع العمل'
                        defaultValue={instance?.work_type || 'meter_installation'}
                        select
                    >
                        <ListSubheader sx={{bgcolor: 'transparent'}}>المشتركين</ListSubheader>
                        <MenuItem value='meter_installation'>عداد</MenuItem>
                        <MenuItem value='network_connection'>تنفيذ شبكة</MenuItem>
                        <ListSubheader sx={{bgcolor: 'transparent'}}>العمليات والصيانة</ListSubheader>
                        <MenuItem value='emergency_response'>طوارئ</MenuItem>
                        <MenuItem value='asset_replacement'>إحلال</MenuItem>
                        <MenuItem value='network_upgrade'>التعزيز</MenuItem>
                        <MenuItem value='medium_voltage_operations'>الجهد المتوسط</MenuItem>
                        <ListSubheader sx={{bgcolor: 'transparent'}}>أخرى</ListSubheader>
                        <MenuItem value='projects'>المشاريع</MenuItem>
                        <MenuItem value='assets'>الأصول</MenuItem>
                    </FormTextField>
                    {workType === 'assets' && (
                        <Box sx={{
                            display: 'flex',
                            gap: 2
                        }}>
                            <FormTextField
                                name='equipment_no'
                                label='رقم المُعدّة'
                            />
                            <FormTextField
                                name='site_type'
                                label='نوع الموقع'
                                defaultValue={instance?.site_type || 'cns'}
                                select
                            >
                                <MenuItem value='cns'>CNS</MenuItem>
                                <MenuItem value='cds'>CDS</MenuItem>
                            </FormTextField>
                        </Box>
                    )}
                    <Box sx={{
                        display: 'flex',
                        gap: 2
                    }}>
                        <FormTextField
                            name='office'
                            label='المكتب'
                            defaultValue={instance?.office || ''}
                            select
                        >
                            <MenuItem value=''>---------</MenuItem>
                            {(!offices.isLoading && !offices.error && offices.data) && (
                                offices.data.map(office => (
                                    <MenuItem
                                        key={office.id}
                                        value={office.id}
                                    >{office.name}</MenuItem>
                                ))
                            )}
                        </FormTextField>
                        <FormTextField
                            name='district'
                            label='الحي'
                        />
                    </Box>
                    <Controller
                        name='is_draft'
                        control={control}
                        defaultValue={false}
                        render={({ field }) => (
                            <FormControl sx={{ mt: 3 }}>
                                <FormLabel>حالة الطلب</FormLabel>

                                <RadioGroup
                                    row
                                    value={field.value ? 'draft' : 'done'}
                                    onChange={(e) => {
                                        field.onChange(e.target.value === 'draft')
                                    }}
                                    sx={{gap: 1}}
                                >
                                    <FormControlLabel
                                        value='done'
                                        control={<Radio />}
                                        label='منجز'
                                    />

                                    <FormControlLabel
                                        value='draft'
                                        control={<Radio />}
                                        label='قيد التنفيذ'
                                    />
                                </RadioGroup>
                            </FormControl>
                        )}
                    />
                    <FormTextField
                        name='notes'
                        label='وصف العمل'
                        rows={4}
                        multiline
                    />
                    <br />
                    <Divider />
                    <br />
                    <Typography variant='caption'>بيانات إختيارية</Typography>
                    <FormTextField
                        name='supervisor_name'
                        label='اسم المشرف'
                    />
                    <SignatureField
                        label='توقيع المشرف'
                        name='supervisor_signature'
                    />
                    <FormTextField
                        name='pdc_delegate'
                        label='ممثل الـ PDC'
                        defaultValue={instance?.pdc_delegate || ''}
                        select
                    >
                        <MenuItem value=''>---------</MenuItem>
                        {(!delegates.isLoading && !delegates.error && delegates.data) && (
                            delegates.data.map(delegate => (
                                <MenuItem
                                    key={delegate.id}
                                    value={delegate.id}
                                >{delegate.name}</MenuItem>
                            ))
                        )}
                    </FormTextField>
                    <FormTextField
                        name='station_no'
                        label='رقم المحطة'
                    />
                    {!!instance?.active_users &&
                        <Stack
                            spacing={2}
                            sx={{mt: 3}}
                        >
                                <Divider />
                                <Typography variant='caption'>المهندسون المشاركون</Typography>
                                <List>
                                    {instance.active_users?.map(user => (
                                        <ConsultantItem
                                            key={user.id}
                                            id={user.id}
                                            name={user.name}
                                            lastActivity={user.last_activity}
                                            disableGutters
                                        />
                                    ))}
                                </List>
                        </Stack>
                    }
                </Stack>
                <input
                    type='file'
                    accept='.jpg,.jpeg,.png,.webp,.bmp,.tif,.tiff,.avif,.gif,image/jpeg,image/png,image/webp,image/bmp,image/tiff,image/avif,image/gif'
                    ref={imgUploaderRef}
                    onChange={uploadImage}
                    multiple
                    hidden
                />
                <input
                    type='file'
                    accept='.pdf,application/pdf'
                    ref={atchUploaderRef}
                    onChange={uploadAttachment}
                    multiple
                    hidden
                />
                {/* Documents */}
                <Box sx={{
                    display: tab === 'documents' ? 'flex' : 'none',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {images.filter(image => image.dep === 'documents').length === 0
                        ? (<>
                            <Typography>ما من نماذج</Typography>
                            <Box sx={{
                                display: 'flex',
                                gap: 1,
                                mt: 2
                            }}>
                                <Button
                                    sx={{boxShadow: 0}}
                                    variant='contained'
                                    onClick={() => imgUploaderRef.current.click()}
                                >إضافة صور</Button>
                                <Button
                                    sx={{boxShadow: 0}}
                                    variant='contained'
                                    onClick={viewDocs}
                                >نموذج رقمي</Button>
                            </Box>
                        </>) : (
                            <>
                                <Box sx={{
                                    width: '100%',
                                    mb: 1
                                }}>
                                    <Tooltip title='إضافة صور'>
                                        <IconButton onClick={() => imgUploaderRef.current.click()}><AddIcon /></IconButton>
                                    </Tooltip>
                                    <Tooltip title='نموذج رقمي'>
                                        <IconButton onClick={viewDocs}><PostAddIcon /></IconButton>
                                    </Tooltip>
                                </Box>
                                <Images
                                    images={images.filter(image => image.dep === 'documents')}
                                    onCrop={viewCropper}
                                />
                            </>
                        )
                    }
                </Box>

                {/* Location */}
                <Box sx={{
                    display: tab === 'location' ? 'flex' : 'none',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {images.filter(image => image.dep === 'location').length === 0
                        ? (<>
                            <Typography>ما من صور</Typography>
                            <Box sx={{
                                display: 'flex',
                                gap: 1,
                                mt: 2
                            }}>
                                <Button
                                    sx={{boxShadow: 0}}
                                    variant='contained'
                                    onClick={() => imgUploaderRef.current.click()}
                                >إضافة صور</Button>
                            </Box>
                        </>) : (<>
                            <IconButton
                                sx={{
                                    alignSelf: 'end',
                                    mb: 1
                                }}
                                onClick={() => imgUploaderRef.current.click()}
                            ><AddIcon /></IconButton>
                            <Images
                                images={images.filter(image => image.dep === 'location')}
                                onCrop={viewCropper}
                            />
                        </>)
                    }
                </Box>

                {/* Violations */}
                <Box sx={{
                    display: tab === 'violations' ? 'flex' : 'none',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {images.filter(image => image.dep === 'violations').length === 0
                        ? (<>
                            <Typography>ما من صور</Typography>
                            <Box sx={{
                                display: 'flex',
                                gap: 1,
                                mt: 2
                            }}>
                                <Button
                                    sx={{boxShadow: 0}}
                                    variant='contained'
                                    onClick={() => imgUploaderRef.current.click()}
                                >إضافة صور</Button>
                            </Box>
                        </>) : (<>
                            <IconButton
                                sx={{
                                    alignSelf: 'end',
                                    mb: 1
                                }}
                                onClick={() => imgUploaderRef.current.click()}
                            ><AddIcon /></IconButton>
                            <Images
                                images={images.filter(image => image.dep === 'violations')}
                                onCrop={viewCropper}
                            />
                        </>)
                    }
                </Box>

                {/* Attachments */}
                <Box sx={{
                    display: tab === 'attachments' ? 'flex' : 'none',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {attachments.length === 0
                        ? (<>
                            <Typography>ما من مرفقات .pdf</Typography>
                            <Box sx={{
                                display: 'flex',
                                gap: 1,
                                mt: 2
                            }}>
                                <Button
                                    sx={{boxShadow: 0}}
                                    variant='contained'
                                    onClick={() => atchUploaderRef.current.click()}
                                >إضافة مرفق</Button>
                            </Box>
                        </>) : (<>
                            <IconButton
                                sx={{
                                    alignSelf: 'end',
                                    mb: 1
                                }}
                                onClick={() => atchUploaderRef.current.click()}
                            ><AddIcon /></IconButton>
                            <Attachments
                                attachments={attachments}
                            />
                        </>)
                    }
                </Box>
            </DialogContent>
            <DialogActions sx={{display: dialogMode == 'fields' ? 'flex' : 'none'}}>
                {!!instance &&
                    <Button
                        variant='text'
                        onClick={handlePreview}
                        disabled={loading}
                    >معاينة</Button>
                }
                <div style={{flexGrow: 1}}></div>
                <Button
                    variant='text'
                    onClick={handleClose}
                    disabled={loading}
                >إغلاق</Button>
                <Button
                    variant='text'
                    type='submit'
                    disabled={loading}
                >حفظ</Button>
            </DialogActions>
        </>
    )
}